import React from "react";
import { chunk } from "lodash";
import { useAuth } from "@/components/auth/hooks/useAuth";
// BOOTSTRAP
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import FadeCatalog from "@/components/elements/FadeCatalog/FadeCatalog";
// STYLE
import s from "./GridGenerator.module.scss";

type GridGeneratorProps = {
  limit: number;
  children: React.ReactNode;
  size?: "sm" | "md" | "lg";
};
const GridGenerator: React.FC<GridGeneratorProps> = ({ limit, children, size = "sm" }) => {
  // cols it is remodfved from props because was unused in this case, could re-enter cols and use it in some
  // Row breakpoint at line 17, then should calculate other breakpoints based on the value
  // const colWidth = 12 / cols
  const auth = useAuth();
  const rows = chunk(React.Children.toArray(children), 60);

  let arr = [2, 3, 4, 6];
  switch (size === "sm" || size === "md" || size === "lg") {
    case size === "sm":
      arr = [2, 3, 4, 6];
      break;
    case size === "md":
      arr = [3, 4, 5, 7];
      break;
    case size === "lg":
      arr = [4, 5, 6, 8];
      break;
  }

  return (
    <Container fluid style={{ position: "relative" }}>
      {rows.map((cols, i) => (
        <Row key={`row-${cols[i]?.["key"]}`} xs={arr[0]} sm={arr[1]} lg={arr[2]} xxl={arr[3]}>
          {cols.map((col, key) =>
            !auth.user ? (
              // Limit number of displayed items
              key < limit && (
                <Col key={`col-${col["key"]}`} className="p-1">
                  {col}
                </Col>
              )
            ) : (
              <Col key={`col-${col["key"]}`} className="p-1">
                {col}
              </Col>
            )
          )}
        </Row>
      ))}
      {/* Add login / signup component with fade overlay */}
      {!auth.user && (
        <div className={s.fade_catalog_wrapper}>
          <FadeCatalog />
        </div>
      )}
    </Container>
  );
};
export default GridGenerator;
